// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__9dvXw","links":"Sidebar_links__RdSFB","themeButton":"Sidebar_themeButton__GhPhx"};